import { Divider } from "antd";
import React, { useEffect, useState } from "react";
import { Modal, OverlayTrigger, Popover } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import { BaseURL } from "../../../constants/enum/baseURL.emum";
import doc5Service from "../../../services/doc5.service";
import ShowDoc from "../../common/showDoc";

const ShowDoc5 = (props: any) => {
  const { doc3, type, course, schedule } = props;
  // console.log(doc3);
  // console.log(course);
  // console.log(schedule);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [doc5List, setDoc5List] = useState([]);

  useEffect(() => {
    (async () => {
      await doc5Service.getByDoc3(Number(doc3.id)).then((res: any) => {
        setDoc5List(res.data);
      });
    })();
  }, []);

  return (
    <>
      <Button variant="warning" onClick={handleShow} className="me-2 btn-sm">
        {type}5
      </Button>
      <Offcanvas show={show} onHide={handleClose} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            ปีการศึกษา {schedule.year} เทอม {schedule.term}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="row">
            <h4>รายวิชา {course.name}</h4>
          </div>
          <div className="row">
            <p>รายวิชา {course.courseCode}</p>
          </div>
          {/* <Divider orientation="right">Right Text</Divider> */}
          <Divider>รายการเอกสาร {type}5</Divider>
          {doc5List.length === 0 && (
            <div className="row">
              <div className="col text-center text-danger">
                ยังไม่ส่ง {type}5
              </div>
            </div>
          )}

          {doc5List.map((doc5: any) => {
            return (
              <div key={doc5.id} className="row mt-3">
                <div className="col">{doc5.group}</div>
                <div className="col-3">
                  <ShowDoc
                    btnName={``}
                    url={`${BaseURL.BASE_URL}/upload/doc5/${doc5.pathFile}`}
                  />
                </div>
              </div>
            );
          })}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default ShowDoc5;
